module.exports = __webpack_public_path__ + "img/GN.c4b229eb.svg";